import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";
import { getRoles } from "../../../api";
import type { RoleItem } from "../../../types/role";

type RoleSelectValue = {
  id?: number;
  name?: string;
};

type RoleSelectProps = {
  changedValue: (value: RoleSelectValue) => void;
};

const RoleSelect = ({ changedValue }: RoleSelectProps) => {
  const [roles, setRoles] = useState<RoleItem[]>([]);

  const fetchRoles = async () => {
    try {
      const response = await getRoles({
        order: null,
        sort: null,
        page: 1,
      });
      console.log("権限取得", response);
      if (response.status === "ok") {
        setRoles(response.m_roles);
      } else {
        console.error("ヒットする権限なし");
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: RoleItem | null
  ) => {
    changedValue({ id: newValues?.id, name: newValues?.name });
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={roles}
      getOptionLabel={(role) => role.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField {...params} name="roleSelect" label="権限選択" />
      )}
      onChange={handleChange}
    />
  );
};

export default RoleSelect;
